<template>
  <div class="row">
    <div class="col">
      <div class="card card-modern">
        <div class="card-body">
          <div class="datatables-header-footer-wrapper">
            <div class="datatable-header">
              <div class="row mb-3">
                <div
                  class="col-8 d-flex mb-3 mb-lg-0 d-flex align-items-center"
                  >
                  <a
                    class="
                      btn btn-primary btn-md
                      font-weight-semibold
                      btn-py-2
                      px-4
                    "
                    @click.prevent="exportToExcel"
                    >Export</a
                  >
                </div>
                <div class="col-8 col-lg-auto ms-auto ml-auto mb-3 mb-lg-0">
                </div>
                <div class="col-4 col-lg-auto ps-lg-1 mb-3 mb-lg-0">
                  <div
                    class="d-flex align-items-lg-center flex-column flex-lg-row"
                  >
                    <select
                      class="form-control select-style-1 results-per-page"
                      name="results-per-page"
                      v-model="searchConfig.pageSize"
                      @change="changePageSize(searchConfig.pageSize)"
                    >
                      <option
                        :value="page"
                        v-for="page in pageSizeList"
                        :key="page"
                      >
                        {{ page }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-lg-auto ps-lg-1">
                  <div
                    class="search search-style-1 search-style-1-lg mx-lg-auto"
                  >
                    <div class="input-group">
                      <input
                        type="text"
                        class="search-term form-control"
                        placeholder="Search"
                        v-model="searchField"
                        @input="debounceInput"
                      />
                      <button class="btn btn-default" type="submit">
                        <i class="bx bx-search"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="dataTables_wrapper dt-bootstrap5 no-footer" v-if="list.length > 0">
              <div class="table-responsive">
                <table
                  class="
                    table table-ecommerce-simple table-striped
                    mb-0
                    dataTable
                    no-footer
                  "
                >
                  <thead>
                    <tr role="row">
                      <th class="sorting_disabled">
                        <input
                          type="checkbox"
                          class="select-all checkbox-style-1 p-relative top-2"
                          v-model="selectAll"
                        />
                      </th>
                      <th class="sorting">Rbr</th>
                      <th class="sorting">E-mail korisnika</th>
                      <th class="sorting">Platforma</th>
                      <th class="sorting">Datum kreiranja</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      role="row"
                      v-for="(newsletter, index) in list"
                      :key="newsletter.id"
                      :class="{ odd: index % 2 === 0, even: index % 2 !== 0 }"
                    >
                      <td width="30">
                        <input
                          type="checkbox"
                          class="checkbox-style-1 p-relative top-2"
                          :value="newsletter.id"
                          v-model="selected"
                          @click.stop
                        />
                      </td>
                      <td>
                          <strong>{{ ((pager.currentPage - 1) * (searchConfig.pageSize)) + index + 1 }}</strong>
                      </td>
                      <td>
                          <strong>{{ newsletter.email }}</strong>
                      </td>
                      <td>{{ newsletter.type.title }}</td>
                      <td>{{ formatDate(newsletter.createdDate) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-else>
                <div class="alert alert-info" role="alert">
                  {{ translations.noRecords }} <a class="alert-link" @click.prevent="resetFilters">{{ translations.resetFilters }}</a>.
                </div>
              </div>
            <hr class="solid mt-5 opacity-4" />
            <div class="datatable-footer">
              <div class="row align-items-center justify-content-between mt-3">
                <div class="col-md-auto order-1 mb-3 mb-lg-0">
                  <div class="d-flex align-items-stretch">
                    <div
                      class="d-grid gap-3 d-md-flex justify-content-md-end me-4"
                    >
                      
                      <select
                        class="form-control select-style-1 bulk-action"
                        name="bulk-action"
                        v-model="bulkAction"
                        style="min-width: 170px"
                      >
                        <option value="bulkAction">Bulk Actions</option>
                        <option value="delete">Delete</option>
                      </select>

                      <button
                        type="button"
                        @click.prevent.stop="handleBulk"
                        class="bulk-action-apply text-color-dark text-3 btn btn-light border btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1">
                        {{ translations.apply }}
                      </button>
                      
                    </div>
                  </div>
                </div>
                <div class="row row-gutter-sm justify-content-between mt-4">
                  <pagination :action="actionName" :pagination-props="paginationProps" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal id="export-modal">
      <h5 slot="header">
        <strong>Exportiraj odabrano</strong>
      </h5>
      <div slot="body">
        <span v-html="'Jeste li sigurni da želite exportirati newsletter korisnike?'"> </span>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              type="button"
              class="btn btn-primary px-4 mx-2"
              @click.prevent.stop="handleBulkAction('newsletters')"
              data-bs-dismiss="modal"
            >
              {{ translations.yes }}
            </button>
            <button
              type="button"
              class="btn btn-default px-4"
              data-bs-dismiss="modal"
            >
              {{ translations.no }}
            </button>
          </div>
        </div>
      </div>
    </modal>

    <modal id="delete-modal">
      <h5 slot="header"><strong>{{ translations.deleteSelected }}</strong></h5>
      <div slot="body">
        <span v-html="modalText">
        </span>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button type="button" class="btn btn-primary px-4 mx-2" @click.prevent.stop="handleBulkAction" data-bs-dismiss="modal">
              {{ translations.yes }}
            </button>
            <button type="button" class="btn btn-default px-4" data-bs-dismiss="modal">
              {{ translations.no }}
            </button>
          </div>
        </div>
      </div>
    </modal>
    <!-- end: page -->
  </div>
</template>

<script>
import { translations, pager } from '@/mixins';
import Pagination from '../shared/Pagination.vue';
import Modal from '../shared/modal/Modal.vue';

export default {
  name: 'Blogs',
  components: { Pagination, Modal },
  mixins: [translations, pager],
  data() {
    return {
      actionName: 'getNewsletters',
      deleteActionName: 'deleteNewsletters',
      bulkActionName: 'deleteNewsletters',
    };
  },
  computed: {
    list() {
      return this.$store.getters.getNewsletters;
    },
    modalText() {
      return this.translations.areYouSureSelected;
    },
    paginationProps() {
      return {}
    }
  },
  mounted() {
    this.$store.dispatch(this.actionName, this.searchConfig);
  },
  methods: {
    openDetails(id) {
      this.$router.push({ name: 'EditNewsletter', params: { id: id } });
    },
    exportToExcel() {
      this.bulkAction = 'export';
      this.handleBulk();
    },
    handleBulk() {
      console.log(this.bulkAction);
      
      if (this.bulkAction !== 'export') {
        $('#delete-modal').modal('show');
      } else {
        this.handleBulkAction('newsletters');
      }
    },
    getNewsletters() {
      this.$store.dispatch(this.actionName, {
        ...this.searchConfig,
        ...this.paginationProps,
        page: 1,
      });

      this.$router
        .push({
          query: {
            ...this.paginationProps,
            page: 1,
          },
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.sorting {
  cursor: pointer;
}

tbody tr {
  cursor: pointer;
}
</style>
